import axios from 'axios';


export const HTTP = axios.create({
  baseURL: "https://api.abrof.com/api/",
  headers: {
  
   "Accept": 'application/json',
   "Content-Type": 'application/json'
  }
})


